import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="page-privacy"
      title="Privacy Policy"
      subtitle={`Welcome to Clocked In One ("we," "our," or "us"). We value your privacy and are committed to protecting any information you choose to share with us through our website.`}
      effectiveDate="August 6, 2026"
      showTemplateDisclaimer={false}
    >
      <p className="text-slate-700 text-[15px] leading-relaxed">
        This Privacy Policy explains what information we collect through <a className="text-[#00A651] font-semibold" href="https://clockedinone.com" target="_blank" rel="noopener noreferrer">https://clockedinone.com</a>, how we use it, and your rights regarding that information.
      </p>

      <Section heading="1. Information We Collect">
        <p>Our website is designed to showcase the features and capabilities of the Clocked In One platform.</p>
        <p>We do not require visitors to create an account, register, or provide personal information to browse our website.</p>
        <p>The only personal information we collect is the information you voluntarily submit through our <b>Contact Us</b> or <b>Request a Demo</b> form, which may include:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Name</li>
          <li>Company name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Any information you choose to include in your message</li>
        </ul>
      </Section>

      <Section heading="2. How We Use Your Information">
        <p>We use the information you submit solely to:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Respond to your enquiry</li>
          <li>Provide information about our products or services</li>
          <li>Schedule demonstrations or meetings if requested</li>
          <li>Communicate with you regarding your enquiry</li>
        </ul>
        <p>We do not use your information for automated decision-making or profiling.</p>
      </Section>

      <Section heading="3. Information We Do Not Collect">
        <p>While you browse our website, we do not intentionally collect or store personal information beyond what you voluntarily provide through our contact form.</p>
        <p>We do not:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Require user registration</li>
          <li>Maintain visitor accounts</li>
          <li>Collect employee records</li>
          <li>Collect payroll or attendance information</li>
          <li>Collect biometric information</li>
          <li>Collect location information</li>
          <li>Sell personal information</li>
        </ul>
      </Section>

      <Section heading="4. Cookies and Tracking Technologies">
        <p>Clocked In One does not use cookies or similar tracking technologies on this website to collect personal information or monitor visitor activity.</p>
        <p>If this changes in the future, we will update this Privacy Policy accordingly.</p>
      </Section>

      <Section heading="5. Sharing of Information">
        <p>We do not sell, rent, or trade your personal information.</p>
        <p>We may share your information only:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>With trusted service providers who help us operate our website or respond to enquiries, where necessary.</li>
          <li>When required by law or legal process.</li>
          <li>To protect our legal rights or prevent fraud or misuse of our website.</li>
        </ul>
      </Section>

      <Section heading="6. Data Security">
        <p>We take reasonable technical and organizational measures to protect the information you provide against unauthorized access, disclosure, alteration, or destruction.</p>
        <p>However, no method of transmitting or storing data electronically is completely secure.</p>
      </Section>

      <Section heading="7. Data Retention">
        <p>We retain information submitted through our contact form only for as long as necessary to respond to your enquiry, maintain business records, or comply with applicable legal obligations.</p>
      </Section>

      <Section heading="8. Third-Party Links">
        <p>Our website may contain links to third-party websites for your convenience.</p>
        <p>We are not responsible for the privacy practices or content of those external websites. We encourage you to review their privacy policies before providing personal information.</p>
      </Section>

      <Section heading="9. Children's Privacy">
        <p>Our website is intended for business users and is not directed toward individuals under the age of 18.</p>
        <p>We do not knowingly collect personal information from children.</p>
      </Section>

      <Section heading="10. Changes to This Privacy Policy">
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page together with the revised Effective Date.</p>
        <p>Your continued use of the website after any changes constitutes acceptance of the updated Privacy Policy.</p>
      </Section>

      <Section heading="11. Contact Us">
        <p>If you have any questions regarding this Privacy Policy or the way we handle your information, please contact us:</p>
        <div className="mt-2 space-y-1">
          <div><b>Clocked In One</b></div>
          <div>Website: <a className="text-[#00A651] font-semibold" href="https://clockedinone.com" target="_blank" rel="noopener noreferrer">https://clockedinone.com</a></div>
          <div>Phone: <a className="text-[#00A651] font-semibold" href="tel:+917976117684">+91-7976117684</a></div>
        </div>
      </Section>
    </LegalLayout>
  );
}
